export const removeHostFromStack = (
	errorStack: string,
	host = window.location.host
): string => {
	return errorStack.replace(new RegExp(host, 'g'), '');
};
